/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { transformEntityToAttrs } from "data/dto/entity/transformers/transform-entity-to-attrs";
import { EntityAttributeEditor } from "./entity-attribute-editor";
import { EntityContext } from "cms/entity/context";
import { dispatch } from "data/store";
import { setCurrentEntity } from "data/store/reducers/entity";
import { getEntitySchema } from "cms/entity/get-entity-schema";

const EntityEditor = (props) => {

    const onEntityChange = props?.onEntityChange;
    
    const entity = useSelector((state) => {
        return state?.entity?.current;
    });
    const schemas = useSelector((state) => {
        return state?.entity?.schemas;
    });
    const schema = getEntitySchema(schemas, entity?.type);
    
    // use a ref to overcome stale closures with updateAttribute
    const entityRef = useRef(entity);
    const latestEntity = entityRef?.current ?? entity; // on first load entityRef might be stale
    const attrs = transformEntityToAttrs(latestEntity, schema);
    const guid = entityRef?.current?.guid;

    useEffect(() => {
        entityRef.current = entity;
    }, [entity]);
    
    const updateAttribute = (name, value) => {
        console.log(name, value);
        const newEntity = { 
            ...entityRef.current,
            [name]: value
        };
        entityRef.current = newEntity;
        dispatch(setCurrentEntity(newEntity));
        onEntityChange(newEntity);
    };

    return (
        <>
            <div style={{ width: "100%" }}>
                <div>
                    <div className="entity-container-wrapper">
                        <div className="entity-container">

                            {attrs?.map((attr,position) => {
                                const name = attr?.key;
                                const value = attr?.value;
                                const type = attr?.type;
                                const entityContext = { 
                                    schema, 
                                    entity: entity.current,
                                    attr,
                                    updateAttribute
                                };
                                
                                return (
                                    <EntityContext.Provider key={position} value={entityContext}>
                                        <EntityAttributeEditor
                                            reference={guid}
                                            type={type}
                                            key={`${name}${position}`}
                                            name={name}
                                            value={value}
                                            position={position}
                                        />
                                    </EntityContext.Provider>
                                );
                            })}

                            {/*<div style={{ fontWeight: "700"}}>Entity Schema</div>*/}
                            {/*<pre style={{ fontSize: "9px", width: "800px", padding: "1rem", overflowX: "auto", backgroundColor: "#ddddff" }}>*/}
                            {/*    {JSON.stringify(schema, null, 2)}*/}
                            {/*</pre>*/}
                            {/*<div style={{ fontWeight: "700"}}>Entity</div>*/}
                            {/*<pre style={{ fontSize: "9px", width: "800px", padding: "1rem", overflowX: "auto", backgroundColor: "#ddddff" }}>*/}
                            {/*    {JSON.stringify(entityRef.current, null, 2)}*/}
                            {/*</pre>*/}
                            {/*<div style={{ fontWeight: "700"}}>Entity Selector</div>*/}
                            {/*<pre style={{ fontSize: "9px", width: "800px", padding: "1rem", overflowX: "auto", backgroundColor: "#ddddff" }}>*/}
                            {/*    {JSON.stringify(entity, null, 2)}*/}
                            {/*</pre>*/}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export { EntityEditor };


// TODO: use schema to include type
//    load schema from SDK
//    "entity.dispute"
// const schema = {
//     title: "Dispute",
//     type: "entity.dispute",
//     version: "1.0.0",
//     attributes: [
//         { type: "date", key: "date", format: "YYYY-MM-DD" },
//         { type: "time", key: "time", format: "HH:mm:ss" },
//         { type: "text", key: "municipality" },
//         { type: "number", key: "ticket" },
//         { type: "text", key: "disputant" },
//         { type: "array:file", key: "evidence" },    // TODO: is this multiple types of files
//     ]
// };


// TODO: implement entity data loading 
// const entity = useSelector((state) => state?.entity?.Entity);
// const defaultEntity = {
//     guid: "29f42d6c-75f8-4018-a8c7-ccc6d89ad0b0",
//     title: "Dispute",
//     type: "entity.dispute",
//     date: "2025-01-01",
//     time: "01:01 pm",
//     municipality: "District of North Vancouver",
//     ticket: "12345678",
//     disputant: "John Doe",
//     evidence: [
//         {
//             filename: "file.png",
//             url: "https://nsbylaw-images.simplicitycms.ca/images/file.png",
//             title: "My File"
//         },
//         {
//             filename: "file2.png",
//             url: "https://nsbylaw-images.simplicitycms.ca/images/file2.png",
//             title: "My File 2"
//         }
//     ]
// };
